import React, { FC } from 'react';
import { Juridiction } from '../../entity.types';
import { juridictionBaseH } from './juridictionChart.utils';

type Props = {
  children: (data: {
    data: Array<number>;
    labels: Array<string>;
    handleClick: (wantToOpenInNewTab: boolean, index: number | null) => void;
    baseH: number;
  }) => React.ReactElement;
  handleClick: (
    wantToOpenInNewTab: boolean,
    juridiction: Juridiction | null,
    index: number | null,
  ) => void;
  juridictions: Array<Juridiction>;
};

export const EnhanceJuridictionChart: FC<Props> = ({
  children,
  juridictions,
  handleClick,
}) => {
  return children({
    data: juridictions.map((j) => j.count),
    labels: juridictions.map((j) => j.abbrev),
    handleClick: (wantToOpenInNewTab, index) => {
      handleClick(
        wantToOpenInNewTab,
        index !== null ? juridictions[index] : null,
        index,
      );
    },
    baseH: juridictionBaseH,
  });
};
